import { render, staticRenderFns } from "./Patches.vue?vue&type=template&id=f05fa3c4&"
import script from "./Patches.vue?vue&type=script&lang=ts&"
export * from "./Patches.vue?vue&type=script&lang=ts&"
import style0 from "./Patches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports